export default "__VITE_ASSET__DN9Y4568__"